/** The version of the SDK the app tells the host in the handshake (kept equal to package.json by a test) */
export const SDK_VERSION = '0.10.0';
